import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';

export default class DropDownTreeViewItemViewModel extends ControlViewModel {

    /**
     * Gibt an, ob das Item geöffnet ist
     */
    public isExpanded: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob das Item auswählbar ist
     */
    public isCheckable: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob das Item angehakt ist
     */
    public isChecked: KnockoutObservable<boolean>;

    /**
     * Definiert den Wert des Items
     */
    public value: KnockoutObservable<any>;

    /**
     * Definiert den Value des Parent-Items
     */
    public parentItem: any;

    /**
     * Enthält den Link
     */
    public link: LinkViewModel;

    /**
     * Enthält die Kindelemente
     */
    public items: KnockoutObservable<Array<DropDownTreeViewItemViewModel>>;

    /**
     * Das ViewModel für ein DropDownTreeViewItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.isExpanded = this.observableOrDefault(params.isExpanded, false);
        this.isCheckable = this.observableOrDefault(params.isEnabled, true);
        this.isChecked = this.observableOrDefault(params.isChecked, false);
        this.value = this.observableOrDefault(params.value, null);
        this.parentItem = this.paramOrDefault(params.parentItem, null);
        this.link = this.paramOrDefault(params.link, null);
        this.items = this.observableOrDefault(params.items, []);
    }
}

ComponentManager.setViewModel('DropDownTreeViewItemViewModel', DropDownTreeViewItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');